<template>
    <div class="admin-exception-time">
        <div class="user-select-wrap">
            <div class="title">
                <h3>{{ $t("exceptionTime.title") }}</h3>
            </div>
            <div class="select-wrapper" v-if="adminDetails.group_owner == 1 && adminDetails.group_active == 1">
                <label class="stylist-label" for="stylist-select"
                    :class="generalOptions.app_id === 5 ? 'loctician' : ''">Select
                    {{
                        generalOptions.app_id === 1
                            ? "Stylist"
                            : generalOptions.app_id === 2
                                ? "Barber"
                                : generalOptions.app_id === 5
                                    ? "Loctician"
                                    : ""
                    }}</label>
                <select id="stylist-select " v-model="forStylistId" class="selectInput selectInputSmall"
                    @change="getExceptions();">
                    <option value="0" disabled>{{ adminDetails.group_name }}</option>
                    <option v-for="(member, index) in groupMembers" v-bind:key="index" v-bind:value="member.user.id"
                        v-bind:disabled="member.active != 1">
                        {{ member.user.first_name }} {{ member.user.last_name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="section-wrap exception-days-main-wrapper">
            <div class="add-free-day-form">
                <div class="item-edit-fields section-wrap" v-if="showform">
                    <div class="item-edit-fields-wrap">
                        <div class="datepicker-wrapper" :class="{ refreshingDatePicker: refreshingDatePicker }">
                            <div class="datepicker-wrap">
                                <!-- DATE -->
                                <div class="fullday-title-wrapper">
                                    <p>Date</p>
                                    <div class="fullday-wrapper">
                                        <label class="toggle">
                                            <input type="checkbox" v-model="fullExceptionDay"
                                                @change="onFullDayToggle" />
                                            <span class="slider"></span>
                                            <span class="label-text">Full Day</span>
                                        </label>
                                    </div>
                                </div>
                                <DatePicker v-model="exceptionDay" @update:model-value="onDateSelected" inline
                                    :time-config="{ enableTimePicker: false }" :auto-apply="true"
                                    :disabled-dates="disabledDates" format="yyyy/MM/dd" />
                            </div>
                            <div v-if="!fullExceptionDay" class="start-end-hour-wrapper">
                                <div class="datepicker-wrap">
                                    <!-- START TIME -->
                                    <p>Start Hour</p>
                                    <DatePicker v-model="startTimeExceptionDate" @update:model-value="updateDateTime"
                                        inline time-picker format="HH:mm" :close-on-auto-apply="true"
                                        :auto-apply="true" />

                                </div>
                                <div class="datepicker-wrap">
                                    <p>End Hour</p>
                                    <!-- END TIME -->
                                    <DatePicker v-model="endTimeExceptionDate" @update:model-value="updateDateTime"
                                        inline time-picker format="HH:mm" :auto-apply="true"
                                        :close-on-auto-apply="true" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="save-free-days-btns">
                        <div>
                            <button class="primary-btn extra-small mobile" @click="saveExceptionDay()">
                                {{ $t("general.save") }}
                            </button>
                        </div>
                        <div>
                            <button class="secondary-btn small mobile" v-on:click="resetModel()">
                                {{ $t("general.cancel") }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="add-new-btn-wrap">
                    <button class="primary-btn extra-small mobile" v-if="!showform" v-on:click="openCalendar()">
                        <i class="fa fa-plus"></i> {{ $t("freeTime.addNew") }}
                    </button>
                </div>
            </div>
            <div class="has-loaderr">
                <div class="content-free-days section-wrap has-loaderr">
                    <template v-for="exception in exceptions">
                        <div v-if="!activeDays[exception.day.toLowerCase()] && loading == true"
                            :key="'exeption-key' + exception.day">
                            <!-- Displaying the day for each exception -->
                            <div class="section-wrap no-shadow">
                                <h5>{{ exception.day }}</h5>
                                <div class="section-wrap exception-info-wrap">
                                    <div class="info-wrapper" v-for="date in exception.dates"
                                        :key="`${exception.day}-datekey-${date.id}`">
                                        <p>
                                            <span class="date">{{ date.dateF }}</span> from: {{ date.work_from }} to:
                                            {{ date.work_to }}
                                        </p>
                                        <div class="buttons-wrapp">
                                            <div @click="editExceptionDay(date)" class="small-button" title="Edit">
                                                {{ $t("freeTime.edit") }}
                                            </div>
                                            <div @click="deleteExceptionDay(date.id)" class="small-button"
                                                title="Delete">
                                                <i class="fa fa-times" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="exception.dates.length === 0" class="info-wrapper">
                                        <p>Click +Add New to add an exception day</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-if="!hasInactiveDays && loading == true">
                        <div>You don't have days off.</div>
                        <div>
                            Please click
                            <router-link :to="{ path: '/app/work-settings/service-hours' }">
                                <span class="main-text-link">here</span>
                            </router-link>
                            to see Service Hours
                        </div>
                    </div>
                    <!---->
                    <div v-if="loading != true" class="loader-wrapp">
                        <div class="loaderr">
                            <i class="fa fa-3x fa-spinner fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from "./../../services/auth.js";
import api from "../../services/apiEndpoints.js";
import store from "./../../services/vuex.js";
import moment from "moment";
import eventBus from "../../services/eventBus.js";
import messages from "./../../services/messages.js";
import { VueDatePicker as DatePicker } from "@vuepic/vue-datepicker";

import $ from "jquery";

export default {
    name: "AdminExceptionTime",
    data: function () {
        return {
            forStylistId: 0,
            exceptions: [
                { day: "Monday", dates: [] },
                { day: "Tuesday", dates: [] },
                { day: "Wednesday", dates: [] },
                { day: "Thursday", dates: [] },
                { day: "Friday", dates: [] },
                { day: "Saturday", dates: [] },
                { day: "Sunday", dates: [] },
            ],
            user: null,
            showform: false,

            dateExceptionDayArray: [],
            datePickerOptions: { placeholder: "Click to choose a date" },
            fullExceptionDay: true,
            timeFrom: {},
            timeTo: {},
            exceptionDayId: 0,
            exceptionDayUserId: 0,
            isFirstTimeSet: false,
            selectedExeptionDate: "",
            work_settings: {},
            weekDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
            workHours: {
                sunday_from: {},
                sunday_to: {},
                sunday_block_from: {},
                sunday_block_to: {},
                monday_from: {},
                monday_to: {},
                monday_block_from: {},
                monday_block_to: {},
                tuesday_from: {},
                tuesday_to: {},
                tuesday_block_from: {},
                tuesday_block_to: {},
                wednesday_from: {},
                wednesday_to: {},
                wednesday_block_from: {},
                wednesday_block_to: {},
                thursday_from: {},
                thursday_to: {},
                thursday_block_from: {},
                thursday_block_to: {},
                friday_from: {},
                friday_to: {},
                friday_block_from: {},
                friday_block_to: {},
                saturday_from: {},
                saturday_to: {},
                saturday_block_from: {},
                saturday_block_to: {},
            },
            activeDays: {
                sunday: 0,
                monday: 0,
                tuesday: 0,
                wednesday: 0,
                thursday: 0,
                friday: 0,
                saturday: 0,
            },
            hasInactiveDays: false,
            loading: false,
            refreshingDatePicker: false,
            latestSelectedDate: new Date(),
            disabledExceptionDates: [],

            exceptionDay: null,
            startTimeExceptionDate: null,
            endTimeExceptionDate: null,

            startExceptionDate: null,
            endExceptionDate: null,
        };
    },
    mounted: function () {
        this.user = this.$auth.state.user;

        this.forStylistId = this.user.id;
        this.getExceptions();
        this.onAdminDetailsLoad();

        eventBus.on("admin_details_loaded", () => {
            this.onAdminDetailsLoad();
        });

        this.getWorkSettings();
    },
    beforeDestroy() { },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
        groupMembers: {
            get: function () {
                return store.state.stylists;
            },
            set: function (value) {
                store.commit("setStylists", value);
            },
        },
    },
    methods: {
        getExceptions() {
            let user_id = this.forStylistId != auth.state.user.id ? this.forStylistId : auth.state.user.id;

            this.$http.get(api.actions.get_exceptions_day + "?user_id=" + user_id).then(
                function (response) {
                    let days = response.data.days;

                    this.exceptions = [
                        { day: "Monday", dates: [] },
                        { day: "Tuesday", dates: [] },
                        { day: "Wednesday", dates: [] },
                        { day: "Thursday", dates: [] },
                        { day: "Friday", dates: [] },
                        { day: "Saturday", dates: [] },
                        { day: "Sunday", dates: [] },
                    ];

                    //eslint-disable-next-line
                    // for (const day of days) {
                    //     let d = moment.utc(day.date).format("DD");
                    //     let m = moment.utc(day.date).format("M") - 1;
                    //     let y = moment.utc(day.date).format("YYYY");

                    //     let fullDate = new Date(Date.UTC(y, m, d));
                    //     let deleteDate = moment(day.date).format("MMM DD");

                    //     // Find the corresponding object in the exceptions array based on the day of the week
                    //     let exception = this.exceptions.find(
                    //         (ex) => ex.day.toLowerCase() === moment(day.date).format("dddd").toLowerCase()
                    //     );
                    //     if (exception) {
                    //         // Push data to the corresponding exception object
                    //         exception.dates.push({
                    //             date: fullDate,
                    //             dateF: deleteDate,
                    //             id: day.id,
                    //             work_from: day.work_from,
                    //             work_to: day.work_to,
                    //         });
                    //     }
                    // }
                    for (const day of days) {
                        // Use local date directly

                        let fullDate = new Date(day.date); // local time

                        let deleteDate = moment(day.date).format("MMM DD");

                        let exception = this.exceptions.find(
                            (ex) => ex.day.toLowerCase() === moment(day.date).format("dddd").toLowerCase()
                        );
                        if (exception) {
                            exception.dates.push({
                                date: fullDate,
                                dateF: deleteDate,
                                id: day.id,
                                work_from: day.work_from,
                                work_to: day.work_to,
                            });
                        }
                    }

                    this.getWorkSettings();

                    //manage disabling dates for selected stylist
                    this.disabledDates.dates = [];
                    if (days && days.length) {
                        const blockedDates = days.map((element) => new Date(element.date));
                        if (blockedDates && blockedDates.length) {
                            this.disabledExceptionDates = days.map(
                                (element) => new Date(element.date)
                            );
                        }
                    }

                    this.showform = false;
                    this.resetModel();
                }.bind(this)
            );
        },
        onAdminDetailsLoad: function () {
            if (this.adminDetails.group_id && this.adminDetails.group_owner) {
                this.getGroupsMembers(this.adminDetails.group_id);
            }
        },
        getGroupsMembers: function (group_id) {
            this.$http.get(api.actions.get_stylist_group_members + group_id).then(
                function (response) {
                    if (typeof response.data.members != "undefined") {
                        this.groupMembers = response.data.members;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        openCalendar() {
            this.showform = !this.showform;
        },
        deleteExceptionDay(id, dates = false) {
            let data = {};
            if (dates) {
                data.dates = dates;
            } else {
                data.id = id;
            }

            if (this.forStylistId != auth.state.user.id) {
                data.group_user_id = this.forStylistId;
            }
            this.$http.post(api.actions.delete_exception_day, data).then(
                function (response) {
                    if (response.data.error == false && id) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                        this.getExceptions();
                    }
                }.bind(this)
            );
        },
        getDefaultWorkIntrval: function (date) {
            const dt = moment(date);
            const weekday = dt.format("dddd").toLowerCase();

            // Default fallbacks if no settings found
            let def_from = "09:00 AM";
            let def_to = "06:00 PM";

            let workFromStr = def_from;
            let workToStr = def_to;

            // Determine which settings to use (Stylist vs Admin)
            if (this.forStylistId != 0 && this.adminDetails.group_active) {
                const stylist = this.groupMembers.find(el => el.user_id == this.forStylistId);
                if (stylist && stylist.work_settings) {
                    workFromStr = stylist.work_settings[weekday + "_from"] || def_from;
                    workToStr = stylist.work_settings[weekday + "_to"] || def_to;
                }
            } else if (this.adminDetails.work_settings) {
                workFromStr = this.adminDetails.work_settings[weekday + "_from"] || def_from;
                workToStr = this.adminDetails.work_settings[weekday + "_to"] || def_to;
            }

            // Convert string times (e.g., "09:00 AM") into JS Date objects for the DatePickers
            const startMoment = moment(workFromStr, ["h:mm A", "HH:mm"]);
            const endMoment = moment(workToStr, ["h:mm A", "HH:mm"]);

            this.startTimeExceptionDate = {
                hours: startMoment.hours(),
                minutes: startMoment.minutes()
            };

            this.endTimeExceptionDate = {
                hours: endMoment.hours(),
                minutes: endMoment.minutes()
            };

            // Maintain your legacy object format if other parts of the app use it
            this.timeFrom = this.processHourFormat(workFromStr);
            this.timeTo = this.processHourFormat(workToStr);
        },

        dateApplied: function (startDate, endDate) {
            this.startExceptionDate = startDate;
            this.endExceptionDate = endDate;
            this.isFirstTimeSet = true;
        },

        editExceptionDay(day) {
            this.resetModel();

            const exceptionDate = new Date(day.date);
            this.exceptionDay = exceptionDate;

            // ✅ DEFINE THESE FIRST
            const startMoment = moment(day.work_from, ["h:mm A", "HH:mm"]);
            const endMoment = moment(day.work_to, ["h:mm A", "HH:mm"]);

            // ✅ NOW you can use them
            const isFullDay =
                startMoment.hours() === 9 &&
                startMoment.minutes() === 0 &&
                endMoment.hours() === 18 &&
                endMoment.minutes() === 0;

            if (isFullDay) {
                this.fullExceptionDay = true;
                this.startTimeExceptionDate = null;
                this.endTimeExceptionDate = null;
            } else {
                this.fullExceptionDay = false;

                // ✅ IMPORTANT: use object format (NOT Date)
                this.startTimeExceptionDate = {
                    hours: startMoment.hours(),
                    minutes: startMoment.minutes()
                };

                this.endTimeExceptionDate = {
                    hours: endMoment.hours(),
                    minutes: endMoment.minutes()
                };
            }

            this.exceptionDayId = day.id;
            this.showform = true;
            this.scrollToTop();
        },
        resetModel() {
            this.exceptionDay = null;
            this.startTimeExceptionDate = null; // Update
            this.endTimeExceptionDate = null;   // Update

            this.startExceptionDate = null;
            this.endExceptionDate = null;

            this.fullExceptionDay = true;
            this.timeFrom = {};
            this.timeTo = {};
            this.exceptionDayId = 0;
            this.exceptionDayUserId = 0;
            this.dateExceptionDayArray = [];
            this.showform = false;
        },
        saveExceptionDay() {
            this.updateDateTime();

            // Validate date selection
            if (!this.exceptionDay) {
                messages.errorMessage("Please select a date");
                return;
            }

            // Validate start/end times if not full day
            if (!this.fullExceptionDay && !this.isStartBeforeEnd(this.startTimeExceptionDate, this.endTimeExceptionDate)) {
                messages.errorMessage("Start time cannot be after end time");
                return;
            }

            // Format the selected date
            const dateStr = moment(this.exceptionDay).format("YYYY/MM/DD");

            // Determine work hours
            let work_from, work_to;

            if (this.fullExceptionDay) {
                work_from = "09:00";
                work_to = "06:00";
            } else {
                work_from = moment({
                    hour: this.startTimeExceptionDate.hours,
                    minute: this.startTimeExceptionDate.minutes
                }).format("h:mm A");

                work_to = moment({
                    hour: this.endTimeExceptionDate.hours,
                    minute: this.endTimeExceptionDate.minutes
                }).format("h:mm A");
            }

            // Build payload based on whether we're editing or adding
            let data = {};

            if (this.exceptionDayId > 0) {
                // Editing an existing exception
                data = {
                    id: this.exceptionDayId,
                    date: dateStr,
                    work_from: work_from,
                    work_to: work_to
                };
            } else {
                // Adding a new exception (matches the required "dates" object format)
                data = {
                    dates: {
                        0: {
                            date: dateStr,
                            work_from: work_from,
                            work_to: work_to
                        }
                    }
                };
            }

            // Include group user ID if different from current user
            if (this.forStylistId !== auth.state.user.id) {
                data.group_user_id = this.forStylistId;
            }

            // Select the correct API endpoint
            const apiUrl = this.exceptionDayId > 0 ? api.actions.edit_exception_day : api.actions.save_exception_days;

            // Send request
            this.$http.post(apiUrl, data).then(response => {
                if (response.data.error === false) {
                    messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                    this.getExceptions();
                    this.resetModel();
                }
            });
        },

        getWorkSettings: function () {
            this.loading = false;
            let stylist_id = this.forStylistId != auth.state.user.id ? "?user_id=" + this.forStylistId : "";

            let getAllSettings = "getAllSettings=1";
            if (stylist_id != "") {
                getAllSettings = "&" + getAllSettings;
            } else {
                getAllSettings = "?" + getAllSettings;
            }

            this.$http.get(api.actions.get_work_settings + stylist_id + getAllSettings).then(
                function (response) {
                    this.loading = true;

                    if (typeof response.data.work_settings != "undefined") {
                        this.work_settings = response.data.work_settings;
                        this.work_settings_clone = Object.assign({}, this.work_settings);
                        this.work_settings.accept_new_clients = Boolean(this.work_settings.accept_new_clients);
                        this.work_settings.prevent_clients_reschedule = !Boolean(
                            this.work_settings.prevent_clients_reschedule
                        );
                        this.work_settings.prevent_clients_book = !Boolean(this.work_settings.prevent_clients_book);
                        this.settings = response.data.settings;
                        this.settings.auto_confirm_appointments = Boolean(this.settings.auto_confirm_appointments);
                        this.settings.accept_website_booking = Boolean(this.settings.accept_website_booking);
                        this.portfolio_url = response.data.portfolio_url;
                        this.timeSlotBooking = response.data.settings.default_slot_time;
                        this.notification_settings = response.data.notification_settings;
                        this.notification_settings.invite = Boolean(this.notification_settings.invite);
                        this.processHours();
                        this.hasInactiveDays = false;
                        for (let day in this.activeDays) {
                            this.activeDays[day] = this.work_settings[day];
                            if (!this.activeDays[day]) {
                                this.hasInactiveDays = true;
                            }
                        }
                    }
                }.bind(this)
            );
            this.loading = false;
        },
        processHours: function () {
            let self = this;
            this.weekDays.forEach(function (day) {
                self.workHours[day + "_from"] = self.processHourFormat(self.work_settings[day + "_from"]);
                self.workHours[day + "_to"] = self.processHourFormat(self.work_settings[day + "_to"]);
                self.workHours[day + "_block_from"] = self.processHourFormat(self.work_settings[day + "_block_from"]);
                self.workHours[day + "_block_to"] = self.processHourFormat(self.work_settings[day + "_block_to"]);
            });
        },
        processHourFormat: function (value) {
            if (!value) {
                return {
                    hh: "",
                    mm: "",
                    A: "AM",
                };
            }

            let obj = moment(value, ["hh:mh A"]);
            let hour = {
                hh: obj.format("hh"),
                mm: obj.format("mm"),
                A: obj.format("A"),
            };

            return hour;
        },
        scrollToTop() {
            const duration = 600; // Scroll duration in milliseconds
            const start = window.scrollY;
            const startTime = "now" in window.performance ? performance.now() : new Date().getTime();

            const scrollToTop = (timestamp) => {
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
                window.scrollTo(0, start + (0 - start) * easeInOutCubic(progress));

                if (elapsed < duration) {
                    requestAnimationFrame(scrollToTop);
                }
            };

            requestAnimationFrame(scrollToTop);
        },
        onDateSelected(date) {
            if (!date) return;

            this.getDefaultWorkIntrval(date);

            if (this.fullExceptionDay) {
                this.startExceptionDate = moment(date).startOf("day").toDate();
                this.endExceptionDate = moment(date).endOf("day").toDate();
            } else {
                this.startExceptionDate = date;
                this.endExceptionDate = date;
            }

            // 🔥 ensure sync
            this.updateDateTime();
        },

        disabledDates(date) {
            // disable past dates
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (date < today) return true;

            // disable inactive weekdays
            const weekDay = moment(date).format("dddd").toLowerCase();
            if (this.activeDays && this.activeDays[weekDay]) return true;

            // disable already saved exception days
            return this.disabledExceptionDates.some(d =>
                moment(d).isSame(date, "day")
            );
        },
        updateDateTime() {
            if (!this.exceptionDay) return;

            let start = new Date(this.exceptionDay);
            let end = new Date(this.exceptionDay);

            if (this.fullExceptionDay) {
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 0, 0);
            } else {
                if (this.startTimeExceptionDate) {
                    start.setHours(
                        this.startTimeExceptionDate.hours,
                        this.startTimeExceptionDate.minutes,
                        0,
                        0
                    );
                }

                if (this.endTimeExceptionDate) {
                    end.setHours(
                        this.endTimeExceptionDate.hours,
                        this.endTimeExceptionDate.minutes,
                        0,
                        0
                    );
                }
            }

            this.startExceptionDate = start;
            this.endExceptionDate = end;
        },
        onFullDayToggle() {
            if (this.fullExceptionDay) {
                // If switching TO Full Day, clear the specific time objects
                this.startTimeExceptionDate = null;
                this.endTimeExceptionDate = null;
            } else {
                // If switching OFF Full Day, load the work settings for that day
                if (this.exceptionDay) {
                    this.getDefaultWorkIntrval(this.exceptionDay);
                }
            }
            this.updateDateTime();
        },
        isStartBeforeEnd(start, end) {
            if (!start || !end) return false; // or true depending on your logic
            const startMinutes = start.hours * 60 + start.minutes;
            const endMinutes = end.hours * 60 + end.minutes;
            return startMinutes <= endMinutes;
        },
    },
    components: {
        DatePicker,
    },
};
</script>